/**
 * Formatierung für die Anzeige. Deutsch, weil die Oberfläche deutsch ist.
 */

const numberFormat = new Intl.NumberFormat('de-DE')
const dateTimeFormat = new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium',
  timeStyle: 'short',
})

/**
 * Zahlen mit Tausenderpunkt.
 *
 * null bleibt sichtbar null und wird nicht zu 0. Ein fehlendes
 * Suchvolumen und ein Suchvolumen von null sind zwei verschiedene
 * Aussagen, und genau daran hängt später das Ranking.
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return '–'
  return numberFormat.format(value)
}

const currencyFormat = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
})

const decimalFormat = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/**
 * Beträge in Euro.
 *
 * Wie formatNumber bleibt null sichtbar null. Ein fehlender CPC und ein
 * CPC von 0,00 € sind zwei verschiedene Aussagen.
 */
export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined) return '–'
  return currencyFormat.format(value)
}

/** Zahlen mit zwei Nachkommastellen, etwa Ranking-Score oder Trend. */
export function formatDecimal(value: number | null | undefined): string {
  if (value === null || value === undefined) return '–'
  return decimalFormat.format(value)
}

export function formatDateTime(value: string | null | undefined): string {
  if (value === null || value === undefined || value === '') return '–'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '–'
  return dateTimeFormat.format(date)
}

const monthNames = [
  'Jan',
  'Feb',
  'Mär',
  'Apr',
  'Mai',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dez',
] as const

export function formatMonth(year: number, month: number): string {
  const name = monthNames[month - 1] ?? String(month)
  return `${name} ${String(year)}`
}
